import dayjs, { Dayjs } from "dayjs";

// const isIsoDate = (str: string): boolean => {
//   if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
//   const d: Date = new Date(str);
//   return d && d instanceof Date && d.toISOString() === str;
// };

export default (date: string | Dayjs): string => {
  try {
    if (!date) {
      throw new Error("Date is not selected");
    }
    const dayjsDate = typeof date === "string" ? dayjs(date) : date;

    if (!dayjsDate.isValid()) {
      throw new Error("Date is not valid");
    }

    const yearMonthDay = dayjsDate.format("YYYY-MM-DD");
    const middayISO = "12:00:00.000Z";
    return yearMonthDay + "T" + middayISO;
  } catch (error) {
    throw error;
  }
};
